<div class="container">
     <div class="content-container">
          @if (sequenceMsg) {
     
          <p>{{sequenceMsg}}</p>
          <ul>
               <li>Sequence Number: {{sequenceDetails.sequenceNumber}}</li>
               <li>EP Year: {{sequenceDetails.year}}</li>
               <li>EP Month: {{sequenceDetails.month}}</li>
               <li>Origination Date: {{sequenceDetails.originationDate}}</li>
          </ul>
          }
          @else if (flightMsg) {
          <p>{{flightMsg}}</p>
          <ul>
               <li>Sequence: {{flightDetails.sequenceNumber}}</li>
               <li>Flight Year: {{flightDetails.year}}</li>
               <li>Flight Month: {{flightDetails.month}}</li>
               <li>Origination Date: {{flightDetails.originationDate}}</li>
               <li>Flight Number: {{flightDetails.flightNumber}}</li>
               <li>Flight Departure: {{flightDetails.depAirport}}</li>
               <li>Flight Arrival: {{flightDetails.arrAirport}}</li>
               <li>Flight Date: {{flightDetails.flightDate}}</li>
          </ul>
          }
     </div>
     <div class="button-container" *ngIf="appService.theme$ | async as theme">
          <button rRipple class="confirm-button" type="button" (click)="onConfirm()" [style]="{
                    'background': theme === 'light' ? 'var(--p-primary-600)' : 'transparent',
                    'color' : theme === 'light' ? 'var(--p-surface-0)' : 'var(--p-primary-600)'
                    }">OK
          </button>
     </div>
</div>